var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-service" }, [
    _c(
      "ul",
      _vm._l(_vm.list, function(item, index) {
        return _c("li", { key: index }, [
          _c(
            "div",
            {
              class:
                "has-icon add-icon " +
                (_vm.isTrasferimento ? "add-transfer" : "add-task") +
                " d-flex justify-content-between"
            },
            [
              _c(
                "div",
                [
                  _c("p", [_vm._v(_vm._s(item.detail.name))]),
                  _vm._v(" "),
                  _vm._l(item.groups, function(group, index) {
                    return !item.isTrasferimento &&
                      _vm.isSameDate(group.dateSelected, _vm.day)
                      ? _c(
                          "small",
                          {
                            key: index,
                            staticClass: "mr-1",
                            attrs: { value: group }
                          },
                          [_vm._v("Camera " + _vm._s(group.id))]
                        )
                      : _vm._e()
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tools" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn info",
                    on: {
                      click: function($event) {
                        return _vm.onClickInfo(item)
                      }
                    }
                  },
                  [_c("div")]
                ),
                _vm._v(" "),
                _vm.isDeletable(item)
                  ? _c(
                      "button",
                      {
                        staticClass: "btn delete",
                        on: {
                          click: function($event) {
                            return _vm.onClickDelete(_vm.day, item)
                          }
                        }
                      },
                      [_c("div")]
                    )
                  : _vm._e()
              ])
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c9bdc91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9bdc91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/itinerario/ItemService.vue
// module id = null
// module chunks = 